import { render, staticRenderFns } from "./NormalSearchNav240.vue?vue&type=template&id=0540c201&scoped=true"
import script from "./NormalSearchNav240.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav240.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0540c201",
  null
  
)

export default component.exports